import {
  COMMON_SAVE_CRASH_REPORT_BEGIN,
  COMMON_SAVE_CRASH_REPORT_SUCCESS,
  COMMON_SAVE_CRASH_REPORT_FAILURE,
  COMMON_SAVE_CRASH_REPORT_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function saveCrashReport(args = {}) {
  return dispatch => {
    dispatch({
      type: COMMON_SAVE_CRASH_REPORT_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(`${process.env.REACT_APP_BUILDER_ENGINE}crash-report/`, args);
      doRequest.then(
        res => {
          dispatch({
            type: COMMON_SAVE_CRASH_REPORT_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        err => {
          dispatch({
            type: COMMON_SAVE_CRASH_REPORT_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSaveCrashReportError() {
  return {
    type: COMMON_SAVE_CRASH_REPORT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_SAVE_CRASH_REPORT_BEGIN:
      return {
        ...state,
        saveCrashReportPending: true,
        saveCrashReportError: null,
      };

    case COMMON_SAVE_CRASH_REPORT_SUCCESS:
      return {
        ...state,
        saveCrashReportPending: false,
        saveCrashReportError: null,
      };

    case COMMON_SAVE_CRASH_REPORT_FAILURE:
      return {
        ...state,
        saveCrashReportPending: false,
        saveCrashReportError: action.data.error,
      };

    case COMMON_SAVE_CRASH_REPORT_DISMISS_ERROR:
      return {
        ...state,
        saveCrashReportError: null,
      };

    default:
      return state;
  }
}
